var _ = require('lodash');
window.$ = window.jQuery = require('jquery');

//require('materialize-css');
require('sweetalert');
require ('slick-carousel');
require ('jquery-modal');

require('./views/index');
require('./views/contact');
require('./views/emptycart');
require('./views/shop');
require('./views/product');
require('./views/profile');
require('./views/update');
require('./views/order');
require('./views/cart');
require('./views/login');
require('./views/register');
require('./views/shipping');
require('./views/search');
require('./views/payu');
require('./views/terms');

$('.modal_design').click(function (e) {
    if($(e.target).parents('.rowFirst').length == 0){
        $('.modal_design').css('display','none');
    }
});
$('.close-modal').click(function (e) {
    $('.modal_design').css('display','none');
});


$('.float_cookie .close').click(function (){
    localStorage.setItem('cookie', '1');
    $('.float_cookie').hide();
});
if (window.localStorage.getItem('cookie') !== undefined){
    var aValue = localStorage.getItem('cookie');
    if(aValue == '1'){
        $('.float_cookie').hide();
    }
}else{
    localStorage.setItem('cookie', '0');
}

const clickProducts = document.getElementById('clickProducts'),
menuMobile = document.getElementById('menuMobile');

var validate_clickProducts = 1;
clickProducts.addEventListener('click', ()=>{
  if(validate_clickProducts == 1){
    validate_clickProducts = 2;
    document.body.classList.toggle('lock-screen');
    menuMobile.classList.toggle('menuMobileActive');
  }else{
    validate_clickProducts = 1;
    document.body.classList.remove('lock-screen');
    menuMobile.classList.remove('menuMobileActive');
  }
})

////codigo de eugenio
const categories = document.getElementById('allCategories'),
closeCategories = document.getElementById('closeCategories'),
openCategories = document.getElementById('openCategories'),
openMarcas = document.getElementById('openMarcas'),
openLines = document.getElementById('openLines'),
subMarca = document.getElementById('subMarca'),
subLine = document.getElementById('subLine'),
closeMarcas = document.getElementById('closeMarcas'),
closeLines = document.getElementById('closeLines'),
backMarcas = document.getElementById('subBack'),
backLines = document.getElementById('subLines'),
subProduct = document.getElementById('subProduct'),
openProduct = document.getElementById('openProduct'),
closeProduct = document.getElementById('closeProduct'),
backProduct = document.getElementById('backProduct'),
subYear = document.getElementById('subYear'),
openYear = document.getElementById('openYear'),
closeYear = document.getElementById('closeYear'),
backYear = document.getElementById('backYear'),
subVehicle = document.getElementById('subVehicle'),
openVehicle = document.getElementById('openVehicle'),
closeVehicle = document.getElementById('closeVehicle'),
backVehicle = document.getElementById('backVehicle'),
subSize = document.getElementById('subSize'),
openSize = document.getElementById('openSize'),
closeSize = document.getElementById('closeSize'),
backSize = document.getElementById('backSize'),
subPrice = document.getElementById('subPrice'),
openPrice = document.getElementById('openPrice'),
closePrice = document.getElementById('closePrice'),
backPrice = document.getElementById('backPrice'),
showMenuPay = document.getElementById('showMenuPay'),
floatshowMenuPay = document.getElementById('floatshowMenuPay');



if(categories){
  /*SHOW*/
  openCategories.addEventListener('click', ()=>{
    document.body.classList.toggle('lock-screen')
    categories.classList.toggle('show')
  })
  
  openMarcas.addEventListener('click', ()=>{
    subMarca.classList.toggle('show')
  })

  openLines.addEventListener('click', ()=>{
    subLine.classList.toggle('show')
  })

  openProduct.addEventListener('click', ()=>{
    subProduct.classList.toggle('show')
  })
  openYear.addEventListener('click', ()=>{
      subYear.classList.toggle('show')
  })

  openVehicle.addEventListener('click', ()=>{
    subVehicle.classList.toggle('show')
  })

  /*openSize.addEventListener('click', ()=>{
    subSize.classList.toggle('show')
  })*/
  
  openPrice.addEventListener('click', ()=>{
    subPrice.classList.toggle('show')
  })

  /*HIDDEN*/
  closeCategories.addEventListener('click', ()=>{
    document.body.classList.toggle('lock-screen')
    categories.classList.remove('show')
  })
  
  closeMarcas.addEventListener('click', ()=>{
    document.body.classList.toggle('lock-screen')
    categories.classList.add('show')
    subMarca.classList.remove('show')
  })  
  
  closeLines.addEventListener('click', ()=>{
    document.body.classList.toggle('lock-screen')
    categories.classList.add('show')
    subLine.classList.remove('show')
  })

  
  
  closeProduct.addEventListener('click', ()=>{
    document.body.classList.toggle('lock-screen')
    categories.classList.remove('show')
    subProduct.classList.remove('show')
  })

  closePrice.addEventListener('click', ()=>{
    document.body.classList.toggle('lock-screen')
    categories.classList.remove('show')
    subPrice.classList.remove('show')
  })

  closeYear.addEventListener('click', ()=>{
    document.body.classList.toggle('lock-screen')
    categories.classList.remove('show')
    subYear.classList.remove('show')
  })

  closeVehicle.addEventListener('click', ()=>{
    document.body.classList.toggle('lock-screen')
    categories.classList.remove('show')
    subVehicle.classList.remove('show')
  })

  closeSize.addEventListener('click', ()=>{
    document.body.classList.toggle('lock-screen')
    categories.classList.remove('show')
    subSize.classList.remove('show')
  })

  closePrice.addEventListener('click', ()=>{
    document.body.classList.toggle('lock-screen')
    categories.classList.remove('show')
    subPrice.classList.remove('show')
  })

  //BACKS
  backMarcas.addEventListener('click', ()=>{
    subMarca.classList.remove('show')
  })
  backLines.addEventListener('click', ()=>{
    subLine.classList.remove('show')
  })
  backProduct.addEventListener('click', ()=>{
    subProduct.classList.remove('show')
  })
  backYear.addEventListener('click', ()=>{
    subYear.classList.remove('show')
  })
  backVehicle.addEventListener('click', ()=>{
    subVehicle.classList.remove('show')
  })
  backSize.addEventListener('click', ()=>{
    subSize.classList.remove('show')
  })
  backPrice.addEventListener('click', ()=>{
    subPrice.classList.remove('show')
  })
}
let validate = 1;
showMenuPay.addEventListener('click', ()=>{
  if(validate == 1){
    validate = 2;
    $('.floatw3').css('display','flex');
    $('.floatw4').css('display','flex');
    //floatshowMenuPay.classList.add('activo')
  }else{
    validate = 1;
    $('.floatw3').css('display','none');
    $('.floatw4').css('display','none');
    //floatshowMenuPay.classList.remove('activo')
  }
})

require('./instagram');
require('./sliders');
require('./search');
let validate_share = 1;
$('.share_float').click(function(){
  if(validate_share == 1){
    validate_share = 2;
    $('.share_div').css('display','flex');
    $('.share_div').css('opacity','1');
  }else{
    validate_share = 1;
    $('.share_div').css('display','none');
    $('.share_div').css('opacity','0');
  }
});
$('.share_wp').click(function(){
  window.open('https://api.whatsapp.com/send?text='+window.location.href, '_blank');
});
$('.share_mess').click(function(){
  window.open('https://www.facebook.com/dialog/send?link='+window.location.href, '_blank');
});
$('.share_twitter').click(function(){
  window.open('https://twitter.com/intent/tweet?text='+window.location.href, '_blank');
});
$('.share_face').click(function(){
  window.open('https://www.facebook.com/sharer.php?t='+window.location.href, '_blank');
});